import React, { useEffect, useState } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon
} from "@bringzz/components";
import { useParams } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import { useOrder } from 'context/OrderContext';
import BringzzReadOnlyMap from 'components/BringzzReadOnlyMap';
import BringzzCustomerCardSmall from 'components/BringzzCustomerCardSmall';
import { getOrderTypeString } from 'utils';
import BringzzOrderCardSmallAccordion from 'components/BringzzOrderCardSmallAccordion';
import { toast } from 'react-toastify';
import ImageViewerModal from 'components/ImageViewerModal';

const ShopperOrderViewPage = () => {
    const { backPress, navigate } = useNavigation();
    const { uuid } = useParams();
    const { startMatchingProcess } = useOrder()
    const { sendRequest, loading } = useRequest();
    const [orderDetails, setOrderDetails] = useState()
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
    console.log(orderDetails);

    const fetchOrder = async () => {
        await sendRequest({
            method: 'POST',
            url: `/module/order/getOrder`,
            data: {
                "orderUUID": uuid
            }
        }).then((response) => {
            if (response.status === 'success') {
                setOrderDetails(response.data)
                console.log(response);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        if (!uuid) {
            backPress()
        }
        else {
            fetchOrder()
        }
    }, [])

    const acceptOrder = async () => {
        if (orderDetails) {
            await sendRequest({
                method: 'POST',
                url: `/module/order/acceptOrder`,
                data: {
                    "orderUUID": orderDetails?.integrationId
                }
            }).then((response) => {
                console.log('Accept order response:', response);
                if (response.status === 'success') {
                    if (response.data.order.prescriptionId) {
                        startMatchingProcess(orderDetails, 0)
                        navigate('/matchmaking/shopper/0')
                    } else {
                        startMatchingProcess(orderDetails, 2)
                        navigate('/matchmaking/shopper/2')
                    }
                } else if (response.status === 'error') {
                    console.error('Accept order error response:', response);
                    toast.error(response.message || 'Failed to accept order');
                    // Navigate back to home after showing the error
                    setTimeout(() => {
                        navigate('/')
                    }, 2000);
                } else {
                    console.error('Unexpected response status:', response);
                }
            }).catch((error) => {
                console.error(error);
                toast.error('An error occurred while accepting the order');
            })
        }
    }

    if (!orderDetails) {
        return (
            <BringzzPageContainer
                className="bg-white"
                header={{
                    left: (
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={backPress}
                        />
                    ),
                    title: "Loading Order..."
                }}
                authenticated={true}
            >
                <div className="text-center py-6">
                    <BringzzText tag="h3">Loading...</BringzzText>
                </div>
            </BringzzPageContainer>
        );
    }

    return (
        <BringzzPageContainer
            className="bg-white"
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: `Order #${orderDetails.id || 'Unknown'}`
            }}
            footerHover={true}
            footer={<div className='bg-white'>
                <div className='p-4 justify-center text-center'>
                    <BringzzText tag='h5'>By tapping the accept button, I accept the order from my client. I agree to the terms and conditions and privacy policy.</BringzzText>
                    <div className='flex space-x-2 justify-center mt-2'>
                        <BringzzButton
                            className="bg-white text-red-400 border-red-400 border-2"
                            onClick={() => navigate('/')}
                            disabled={loading}
                        >
                            Decline
                        </BringzzButton>
                        <BringzzButton className="bg-magic-lilac"
                            onClick={acceptOrder}
                            disabled={loading}
                        >Accept</BringzzButton>
                    </div>
                </div>

            </div>}
            authenticated={true}
        >
            {orderDetails && <div className='px-6 pb-60'>
                <div className='text-center my-4'>
                    <BringzzText tag='h1'>€ {orderDetails.totalPrice ? parseFloat(orderDetails.totalPrice).toFixed(2) : '0.00'}</BringzzText>
                    <BringzzText tag='h3'>{orderDetails.products ? orderDetails.products.length : 0} Items</BringzzText>
                    <div>
                        <BringzzText tag="h5" className="font-regular">
                            Estimated payment incl. tip
                        </BringzzText>
                    </div>
                </div>

                <div className="w-full h-64 rounded-lg overflow-hidden">
                    <BringzzReadOnlyMap
                        startLocation={{
                            lat: orderDetails?.pharmacy?.latitude ? parseFloat(orderDetails.pharmacy.latitude) : 48.2082,
                            lng: orderDetails?.pharmacy?.longitude ? parseFloat(orderDetails.pharmacy.longitude) : 16.3738
                        }}
                        endLocation={{
                            lat: orderDetails?.customer?.address?.geoLatitude ? parseFloat(orderDetails.customer.address.geoLatitude) : 48.1951,
                            lng: orderDetails?.customer?.address?.geoLongitude ? parseFloat(orderDetails.customer.address.geoLongitude) : 16.3457
                        }}
                    />
                </div>

                <div className='border-b py-2'>
                    <div className='flex justify-between'>
                        <BringzzText tag='h4' className="font-normal">Estimated total distance</BringzzText>
                        <BringzzText tag='h4' className="font-medium">3.5 km</BringzzText>
                    </div>
                </div>
                
                <div className='border-b py-2'>
                    <div className='flex justify-between'>
                        <BringzzText tag='h4' className="font-normal">Estimated time</BringzzText>
                        <BringzzText tag='h4' className="font-medium">12 mins</BringzzText>
                    </div>
                </div>

                <BringzzCustomerCardSmall customer={orderDetails.customer} />
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconBox9'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className='flex w-full'>
                        <div>
                            <BringzzText tag='h3'>Order Type</BringzzText>
                            <BringzzText tag='h4' className={"font-normal"}>{getOrderTypeString(orderDetails.type || 0)}</BringzzText>
                        </div>
                    </div>
                </div>
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconPin'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className='flex w-full'>
                        <div>
                            <BringzzText tag='h3'>Pharmacy</BringzzText>
                            <BringzzText tag='h4' className={"font-normal"}>{orderDetails.pharmacy?.name || 'Unknown Pharmacy'}</BringzzText>
                        </div>
                    </div>
                </div>
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconFileName'
                            size='22'
                            className='px-3 py-2' />
                    </div>
                    <div className={`flex w-full justify-between ${!orderDetails?.prescriptionId ? 'opacity-35' : ''}`}>
                        <div className='flex items-center'>
                            <BringzzText tag='h3'>Prescription</BringzzText>
                            {orderDetails?.prescriptionId && (
                                <BringzzText tag='h4' className="font-normal ml-2">
                                    {orderDetails.prescription.prescriptionId || orderDetails.prescription.eMedId || ''}
                                </BringzzText>
                            )}
                        </div>
                        {/* <div className='flex items-center space-x-2'>
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconEye'
                                size='22'
                                className={orderDetails?.prescription ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
                                onClick={() => orderDetails?.prescription && setShowPrescriptionModal(true)} />
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconBarcode'
                                size='22' />
                        </div> */}
                    </div>
                </div>
                <BringzzOrderCardSmallAccordion defaultExpanded={false} totalPrice={orderDetails.totalPrice} products={orderDetails.products} fees={orderDetails?.fees?.totalFees || 0} />

                {/* <div className='flex space-x-4 border-b py-2'>
                    <BringzzButton size='sm' className="bg-magic-lilac">Problem with payment?</BringzzButton>
                </div> */}
            </div>}

            {/* Prescription Image Viewer Modal */}
            <ImageViewerModal
                isOpen={showPrescriptionModal}
                onClose={() => setShowPrescriptionModal(false)}
                imageUrl={orderDetails?.prescription?.photo || null}
                title="Prescription"
            />

        </BringzzPageContainer >
    );
};

export default ShopperOrderViewPage;
